import { render, staticRenderFns } from "./section-card.vue?vue&type=template&id=fb2ccace"
import script from "./section-card.vue?vue&type=script&lang=js"
export * from "./section-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports